import { Loader2 } from "lucide-react";

import type { Pro014BulkAction } from "@/@types/campaign";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

import { PRODUCTS_BULK_QUESTION, PRODUCTS_BULK_TITLE, PRODUCTS_TEXTS } from "../constants";

interface BulkActionDialogProps {
  action: Pro014BulkAction | null;
  selectedCount: number;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
}

export function BulkActionDialog({
  action,
  selectedCount,
  isLoading,
  onCancel,
  onConfirm,
}: BulkActionDialogProps): JSX.Element {
  return (
    <AlertDialog open={action !== null} onOpenChange={onCancel}>
      <AlertDialogContent>
        {action && (
          <AlertDialogHeader>
            <AlertDialogTitle>{PRODUCTS_BULK_TITLE[action]}</AlertDialogTitle>
            <AlertDialogDescription>
              {PRODUCTS_BULK_QUESTION[action](selectedCount)}
            </AlertDialogDescription>
          </AlertDialogHeader>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>{PRODUCTS_TEXTS.CANCEL}</AlertDialogCancel>
          <AlertDialogAction onClick={() => void onConfirm()} disabled={isLoading}>
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />}
            {isLoading ? PRODUCTS_TEXTS.PROCESSING : PRODUCTS_TEXTS.CONFIRM}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
